import { useEffect, useState } from 'react'
import { checkToken } from '../utils/auth.utils'
import { useHistory } from 'react-router-dom'

interface Props {
  children?: React.ReactNode
}

export const AuthCheck = ({ children }: Props) => {
  const history = useHistory()
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null)

  useEffect(() => {
    const token = checkToken()
    if (!token) {
      history.push({ pathname: '/login' })
    } else {
      setIsAuthenticated(true)
    }
  }, [history])

  // Show nothing while checking authentication
  if (isAuthenticated === null) {
    return null
  }

  // Render children when authenticated
  return <>{children}</>
}
